import {
    AUTHENTICATING_PARDOT_REQUEST, AUTHENTICATING_PARDOT_SUCCEDDED, AUTHENTICATING_PARDOT_FAILED,
    UPDATING_PARDOT_REQUEST, UPDATING_PARDOT_SUCCEDDED, UPDATING_PARDOT_FAILED
} from '../../actions/actionTypes.jsx';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  }
};

function pardotReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_PARDOT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_PARDOT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_PARDOT_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_PARDOT_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_PARDOT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_PARDOT_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
       
    default:
      return state;
  }
}

export { pardotReducer };